type V4EventUpdate = {
  pinned_comment_id: string | null;
};

export async function apiV4PutEvent(
  channelId: string,
  eventId: string,
  data: V4EventUpdate
): Promise<boolean> {
  const results = await fetch(
    `${process.env.REACT_APP_API_ENDPOINT}/v4/channels/${channelId}/events/${eventId}`,
    {
      method: 'PUT',
      credentials: 'include',
      body: JSON.stringify(data),
      headers: {
        'Content-type': 'application/json',
        Accept: 'application/json'
      }
    }
  );

  return results.ok;
}
